import {
    Typography,
    useTheme,
    Box,
    useMediaQuery,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import LinkRouter from '../../../components/LinkRouter';
import BreadcrumbsComponent from '../../../components/BreadcrumbsComponent';
import { IBreadcrumb } from '../../../components/BreadcrumbsComponent/types';
import AnnouncementsCarousel from '../Announcements/AnnouncementsCarousel';
import Reporting from '../HomePage/reportingSmall';
import AnnouncementsCarouselTablet from '../Announcements/AnnouncementsCarouselTablet';
import AnnouncementsCarouselPhone from '../Announcements/AnnouncementsCarouselPhone';
import HideForms from '../../../components/SendPulseForms/hide';



// Грантодавцям
const ForGrantors = () => {
    const { palette } = useTheme();
    const theme = useTheme();
    const navigate = useNavigate();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const [breadcrumbs, setBreadcrumbs] = useState<Array<IBreadcrumb>>([
        { name: "Партнерам", urlSlug: "/for-partners" },
        { name: "Грантодавцям", urlSlug: "" },
    ]);

    useEffect(() => {
        document.title = `Грантодавцям`;

    }, [])

    return (
        <>
            <HideForms />
            <Box sx={{ mb: { xs: "43px", lg: "120px" } }}>
                <Box sx={{ my: { xs: "11px", md: "28px", lg: "20px" }, mb: { xs: "28px", md: "0px" } }}>
                    <BreadcrumbsComponent elements={breadcrumbs} />
                </Box>
                <Typography variant="h1" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", lg: "36px" }} lineHeight="38px">
                    Грантодавцям
                </Typography>
                <Typography variant="h5" fontFamily="Fixel Display, sans-serif" fontWeight="600" sx={{ mt: { xs: "14px", lg: "34px" }, mb: { xs: "43px", lg: "100px" } }}>
                    Ми активно реалізуємо проєкти у сфері культури, освіти та розвитку молоді, що потребують фінансової підтримки для досягнення масштабних і сталих результатів.
                    <br /><br />
                    Якщо ви грантодавець, який шукає партнерів для впровадження інновацій, ми готові запропонувати прозору співпрацю, орієнтовану на результат.
                    Наша організація має досвід у підготовці грантових заявок, реалізації проєктів відповідно до вимог грантодавців і створенні звітності.
                    <br /><br />
                    Ми працюємо над проєктами, які мають соціальний вплив, сприяють розвитку суспільства та формуванню демократичних цінностей. Разом із вами ми зможемо досягти великих цілей.
                </Typography>
                {/* Анонси */}
                {(isXl || isLg) && <AnnouncementsCarousel />}
                {isMd && <AnnouncementsCarouselTablet />}
                {isXs && <AnnouncementsCarouselPhone />}
                {/* Наша звітність */}
                <Reporting />
            </Box>
        </>
    )
}

export default ForGrantors